import SmartNavigator from '../generic/SmartNavigator'
import GenericKPIs from '../dashboard/GenericKPIs'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import useSmartTranslation from '../generic/hooks/useSmartTranslation/useSmartTranslation'

const MainDashboardTooling = ({ activePath }) => {
  const [config] = useFrontEndConfig()

  const { t_ } = useSmartTranslation()

  if (config === null) return null

  const componentsInfo = [
    {
      title: t_('Operational'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardToolingOperational} />,
      permissionCode: 'DASHBOARD_TOOLING_OPERATIONAL'
    },
    {
      title: t_('Traceability'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardToolingTraceability} />,
      permissionCode: 'DASHBOARD_TOOLING_TRACEABILITY'
    },
    {
      title: t_('Economic'),
      component: <GenericKPIs dashboardsUrl={'/dashboards/d/' + config.dashboardToolingEconomic} />,
      permissionCode: 'DASHBOARD_TOOLING_ECONOMIC'
    }

  ]

  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
}

export default MainDashboardTooling
